import { createSlice, Slice } from "@reduxjs/toolkit";
import { EditorState } from "draft-js";

interface GeneralState {
  shapingData: any;
  perBulletData: any;
  coachRevampData: any;
  perfectingQuestion: any;
  exceSummary: any;
  oldSummary: any;
  skills: any;
  skipCount: number;
  selectCount: number;
}

const initialState = {
  shapingData: {},
  perBulletData: null,
  coachRevampData: null,
  perfectingQuestion: null,
  exceSummary: EditorState.createEmpty(),
  oldSummary: EditorState.createEmpty(),
  skills: null,
  skipCount: 0,
  selectCount: 0,
} as GeneralState;

export const revamp: Slice<GeneralState> = createSlice({
  name: "revamp",
  initialState,
  reducers: {
    setShapingQuestion: (state, action) => {
      return {
        ...state,
        shapingData: action.payload,
      };
    },
    setPerBulletShapingData: (state, action) => {
      return {
        ...state,
        perBulletData: action.payload,
      };
    },
    setPerfectingQuestion: (state, action) => {
      return {
        ...state,
        perfectingQuestion: action.payload,
      };
    },
    setExceSummay: (state, action) => {
      return {
        ...state,
        exceSummary: action.payload,
      };
    },
    setOldSummay: (state, action) => {
      return {
        ...state,
        oldSummary: action.payload,
      };
    },
    setCandidateSkills: (state, action) => {
      return {
        ...state,
        skills: action.payload,
      };
    },
    setSkipCount: (state, action) => {
      return {
        ...state,
        skipCount: action.payload,
      };
    },
    setSelectCount: (state, action) => {
      return {
        ...state,
        selectCount: action.payload,
      };
    },
  },
});

export const {
  setShapingQuestion,
  setPerBulletShapingData,
  setPerfectingQuestion,
  setExceSummay,
  setOldSummay,
  setCandidateSkills,
  setSkipCount,
  setSelectCount,
} = revamp.actions;
export default revamp.reducer;
